export default {
  rules: state => state.rules,
  getPageLoad: state => state.pageLoad,
  getTemplateLoad: state => state.templateLoad,
  getCurrentPage: state => state.currentPage,
  getTemplate: state => state.currentTemplate,
  getEditor: state => state.editor,
  getUser: state => state.user,
  getHost: state => state.host,
  getApi: state => state.api,
  getCityList: state => state.cityList,
  error: state => code => state.error.find(n => n.code === code) || {
    code: 500,
    title: 'Неизвестная ошибка',
    message: 'Неизвестная ошибка'
  }
}


// WEBPACK FOOTER //
// ./src/store/getters.js